import React from 'react';

export const WhatsAppFloat = () => {
  return (
    <a
      href="https://wa.me/5522998342742"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float group"
      aria-label="Contato via WhatsApp"
    >
      <div className="w-16 h-16 bg-[#25D366] hover:bg-[#20BA5A] rounded-full flex items-center justify-center shadow-lg hover:shadow-2xl transition-all">
        <i className="fab fa-whatsapp text-white text-3xl group-hover:scale-110 transition-transform"></i>
      </div>
    </a>
  );
};

export default WhatsAppFloat;